import DOMPurify from "dompurify";

/**
 * Configure DOMPurify once for our doc-template / rich-text HTML use-case.
 * Allows: basic formatting (b/i/u/em/strong), lists, paragraphs, breaks, headings, links, spans, styles.
 * Blocks: scripts, iframes, on* handlers, javascript: URLs, data: URLs (except img which is disabled).
 * Server-side sanitization via _strip_dangerous_html() is our first line; this is defense-in-depth.
 */
const ALLOWED_TAGS = [
  "p", "br", "b", "strong", "i", "em", "u", "s", "strike",
  "ul", "ol", "li",
  "h1", "h2", "h3", "h4",
  "a", "span", "div",
  "blockquote", "pre", "code",
];

const ALLOWED_ATTR = ["href", "target", "rel", "style", "class"];

// Force external links to open safely; strip dangerous targets
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener noreferrer");
  }
});

/**
 * Returns safe HTML string. Never returns anything executable.
 * Pass the result to dangerouslySetInnerHTML.
 */
export const sanitizeHtml = (dirty) => {
  if (!dirty || typeof dirty !== "string") return "";
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input", "button"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover", "onfocus", "onblur"],
    ALLOW_DATA_ATTR: false,
  });
};

/**
 * Convenience: returns the object shape React expects so you can write
 *   <div {...safeHtmlProps(doc.notes_html)} />
 */
export const safeHtmlProps = (dirty) => ({
  dangerouslySetInnerHTML: { __html: sanitizeHtml(dirty) },
});

export default sanitizeHtml;
